import React, { useEffect } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { useNavigate } from 'react-router';
import { Product } from '../../../store/products';
import { AppState } from '../../../store';
import { Modal } from 'react-bootstrap';
import { Loading, UiActions } from '../../../store/ui';
import MapContainer from '../../MapContainer';
import './MapDetail.scss';

interface Props {
  loading: Loading;
  latitude: number;
  longitude: number;
  uiActions: typeof UiActions;
  product: Product;
  addToBasket?: (product: Product, producturn: string) => void;
  removeFromBasket?: (basketEntryId: string, producturn: string) => void;
}

const MapDetailModal = ({ product, latitude, longitude, addToBasket, removeFromBasket }: Props) => {
  const mapRef = React.createRef<HTMLDivElement>();
  const navigate = useNavigate();
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (mapRef.current && event.target instanceof Node && !mapRef.current.contains(event.target)) {
        navigate({ search: '' });
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className='mapDetailModal' ref={mapRef}>
      <Modal.Body className={classNames('background-light-grey custom-modal-body')}>
        <div className='modal-body-content'>
          {latitude && longitude && (
            <div className='mapContainer p-0'>
              <MapContainer
                center={{
                  lat: latitude,
                  lng: longitude,
                }}
                zoom={15}
                locations={{
                  [product?.producturn]: product,
                }}
                addToBasket={addToBasket}
                removeFromBasket={removeFromBasket}
              />
            </div>
          )}
        </div>
      </Modal.Body>
    </div>
  );
};

function mapStateToProps(state: AppState, ownProps: any) {
  return {
    ...ownProps,
    ...state.router,
    ...state.ui,
    location: state.router.location,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    dispatch: dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapDetailModal);
